import { Table } from '@radix-ui/themes';
import { RowClassFn } from 'interfaces/table';
import { RowFn } from 'interfaces/table/column';
import { useMemo } from 'react';

export const CommonTableBodyRow = (props: {
  index: number;
  item: any;
  rowFns: RowFn[];
  rowClassFn?: RowClassFn;
}) => {
  const className = useMemo(
    () => props.rowClassFn?.(props.item, props.index),
    [props.rowClassFn, props.item, props.index]
  );

  const cells = useMemo(
    () => props.rowFns.map((rowFn) => rowFn(props.item)),
    [props.rowFns, props.item]
  );

  return (
    <Table.Row className={className}>
      {cells.map((cell, iCell) => (
        <Table.Cell key={`c-${iCell}`}>{cell}</Table.Cell>
      ))}
    </Table.Row>
  );
};
